import { render, staticRenderFns } from "./page-layout-default.vue?vue&type=template&id=0a2bb932&scoped=true&"
import script from "./page-layout-default.vue?vue&type=script&lang=js&"
export * from "./page-layout-default.vue?vue&type=script&lang=js&"
import style0 from "./page-layout-default.vue?vue&type=style&index=0&id=0a2bb932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2bb932",
  null
  
)

export default component.exports